import { useState, useEffect } from "react";
// redux
import { useSelector } from "react-redux";
// hooks
import { usePageParams } from "../../../hooks/usePageParams";
//axios
import EnhancedAxios from "../../../api/EnhancedAxios";
// mui
import { Stack, Box, Typography, Button } from "@mui/material";
// components
import {
    PageTitle,
    RingsLoader,
    SearchBox,
    SortBox,
    DisableStatusFilterBox,
    LinkButton,
    DownloadCSV,
} from "../../../components";
import { TableGrid, AddPrePaidCard } from "../../../sections";
import { prepaidCardsCols } from "../../../utils/gridCols/prepaidCardsCols";
// alerts
import { errorAlert } from "../../../utils/alerts";
// icons
import { MdAdd } from "react-icons/md";

const PrepaidCards = () => {
    const userToken = useSelector((state) => state.userToken);
    const [loading, setLoading] = useState(true);
    const [cards, setCards] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [totalItems, setTotalItems] = useState(20);
    const [searchValue, setSearchValue] = useState("");
    const [sortValue, setSortValue] = useState("-created_at");
    const [openAddCardForm, setOpenAddCardForm] = useState(false);
    const { page, setPage } = usePageParams();
    const [rerender, setRerender] = useState(false);
    // get all drivers
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `admin/prepaid-cards?page=${page}&paginate=${itemsPerPage}&q=${searchValue}&sorts=${sortValue}`
            )
            .then((res) => {
                setCards(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error) => errorAlert(error));
    }, [page, itemsPerPage, sortValue, searchValue, rerender]);
    return (
        <Stack gap="20px">
            <PageTitle title="إدارة الكروت مسبقة الدفع" />
            <Stack gap="16px">
                <Box>
                    <Button
                        variant="contained"
                        onClick={() => setOpenAddCardForm(true)}
                    >
                        اضافة{" "}
                    </Button>
                    <AddPrePaidCard
                        open={openAddCardForm}
                        setOpen={setOpenAddCardForm}
                        setRerender={setRerender}
                    />
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap="20px"
                    flexWrap="wrap"
                >
                    <SearchBox
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />
                    <SortBox
                        sortValue={sortValue}
                        setSortValue={setSortValue}
                    />
                </Box>
            </Stack>
            <Stack>
                {loading ? (
                    <RingsLoader />
                ) : cards.length === 0 && searchValue === "" ? (
                    <Typography variant="body1" textAlign="center">
                        لا يوجد عناصر لعرضها.
                    </Typography>
                ) : cards.length === 0 && searchValue !== "" ? (
                    <Typography variant="body1" textAlign="center">
                        {" "}
                        لا يوجد عناصر لعرضها خاصة نتيجة البحث.
                    </Typography>
                ) : (
                    <TableGrid
                        rows={cards}
                        cols={prepaidCardsCols}
                        itemsPerPage={itemsPerPage}
                        totalItems={totalItems}
                        currentPage={page}
                        setCurrentPage={setPage}
                    />
                )}
            </Stack>
        </Stack>
    );
};

export default PrepaidCards;
